<template>
  <div>
    <!-- Fundo escurecido atrás do menu -->
    <div
      v-if="showMenuMobile"
      class="menu-mobile-backdrop"
      @click="fecharMenuHeader"
    ></div>

    <div
      class="menu-mobile"
      :class="{ show: showMenuMobile, dark }"
      ref="menuMobile"
    >
      <!-- <div class="logoMobile">
        <router-link to="/aluno/perfil">
          <img v-show="!dark" :src="logo" />
          <img v-show="dark" :src="logoWhite" />
        </router-link>
      </div> -->

      <ul class="menu-mobile-list">
        <li @click="fecharMenuHeader">
          <router-link to="/aluno/perfil" class="user-info">
            <div class="user-avatar">
              <img src="@/assets/user.png" />
            </div>
            <p class="fullName" style="margin: 0px;">{{ fullName }}</p>
          </router-link>
          <span class="line"></span>
        </li>

        <li @click="fecharMenuHeader">
          <router-link to="/aluno">
            <span class="icon-svg">
              <!-- Ícone Home -->
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M575.8 255.5c0 18-15 32.1-32 32.1l-32 0 .7 160.2c0 2.7-.2 5.4-.5 8.1l0 16.2c0 22.1-17.9 40-40 40l-16 0c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1L416 512l-24 0c-22.1 0-40-17.9-40-40l0-24 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64 0 24c0 22.1-17.9 40-40 40l-24 0-31.9 0c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2l-16 0c-22.1 0-40-17.9-40-40l0-112c0-.9 0-1.9 .1-2.8l0-69.7-32 0c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"/></svg>            </span>
            Início
          </router-link>
        </li>

        <li @click="fecharMenuHeader" v-if="dataWebsitePortal2.showInquiry==1">
          <router-link to="/aluno/duvidas">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/></svg>            </span>
            Dúvidas
          </router-link>
        </li>

        <li @click="fecharMenuHeader" v-if="dataWebsitePortal2.showForum==1">
          <router-link to="/aluno/forum">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M64 0C28.7 0 0 28.7 0 64L0 256c0 35.3 28.7 64 64 64l32 0 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320 352 320c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 0zM352 352l-96 0 0 32c0 35.3 28.7 64 64 64l117.3 0 81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3l0-48 32 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-128 0 0 128c0 53-43 96-96 96z"/></svg>
            </span>
            Fóruns
          </router-link>
        </li>

        <li @click="fecharMenuHeader" v-if="dataWebsitePortal2.showCertificates==1">
          <router-link to="/aluno/notificacoes">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416l384 0c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8l0-18.8c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"/></svg>
            </span>
            Avisos
          </router-link>
        </li>

        <li @click="fecharMenuHeader">
          <router-link to="/aluno/certificados">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M128 64c0-35.3 28.7-64 64-64L352 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64l-226.7 0c1.8-5.1 2.7-10.5 2.7-16l0-80c1.3-.5 2.5-1 3.8-1.5c6.8-3 14.3-7.8 20.6-15.5c6.4-7.9 10.1-17.2 11.4-27.1c.5-3.6 .8-5.7 1.1-7.1c1.1-.9 2.8-2.3 5.6-4.5c19.9-15.4 27.1-42.2 17.5-65.5c-1.4-3.3-2.1-5.4-2.6-6.7c.5-1.4 1.2-3.4 2.6-6.7c9.5-23.3 2.4-50.1-17.5-65.5c-2.8-2.2-4.5-3.6-5.6-4.5c-.3-1.4-.6-3.6-1.1-7.1c-3.4-24.9-23-44.6-47.9-47.9c-3.6-.5-5.7-.8-7.1-1.1c-.9-1.1-2.3-2.8-4.5-5.6c-15.4-19.9-42.2-27.1-65.5-17.5c-2.6 1.1-5.1 2.3-6.6 3l-.1 .1L128 64zm384 64l-128 0L384 0 512 128zM109.2 161.6L125 168c1.9 .8 4.1 .8 6.1 0l15.8-6.5c10-4.1 21.5-1 28.1 7.5l10.5 13.5c1.3 1.7 3.2 2.7 5.2 3l16.9 2.3c10.7 1.5 19.1 9.9 20.5 20.5l2.3 16.9c.3 2.1 1.4 4 3 5.2l13.5 10.5c8.5 6.6 11.6 18.1 7.5 28.1L248 285c-.8 1.9-.8 4.1 0 6.1l6.5 15.8c4.1 10 1 21.5-7.5 28.1l-13.5 10.5c-1.7 1.3-2.7 3.2-3 5.2l-2.3 16.9c-1.5 10.7-9.9 19.1-20.5 20.6L192 390.2 192 496c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L128 483.2 88.9 509.3c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-105.8-15.5-2.1c-10.7-1.5-19.1-9.9-20.5-20.6l-2.3-16.9c-.3-2.1-1.4-4-3-5.2L9.1 334.9c-8.5-6.6-11.6-18.1-7.5-28.1L8 291c.8-1.9 .8-4.1 0-6.1L1.6 269.2c-4.1-10-1-21.5 7.5-28.1l13.5-10.5c1.7-1.3 2.7-3.2 3-5.2l2.3-16.9c1.5-10.7 9.9-19.1 20.5-20.5l16.9-2.3c2.1-.3 4-1.4 5.2-3l10.5-13.5c6.6-8.5 18.1-11.6 28.1-7.5zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z"/></svg>
            </span>
            Certificados
          </router-link>
        </li>

        <li @click="changeViewMode" class="viewmode">
          <span v-show="!dark" class="icon-dark">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M284.8 99.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11zm119 211.6c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM191.8 128C85.8 128 0 214.1 0 320.2S85.8 512.4 191.8 512.4c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.2-25.1 2.2c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-5.4-.5-10.8-.7-16.3-.7z"/></svg>
            </span>
            <p style="margin: 0px;">Modo: Escuro</p>
          </span>
          <span v-show="dark" class="icon-light">
            <span class="icon-svg">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"/></svg>
            </span>
            <p style="margin: 0px;">Modo: Claro</p>
          </span>
        </li>

        <!-- <li v-if="typeId === 2" @click="fecharMenuHeader">
          <router-link to="/dashboard/painel">
            <span class="icon-svg">
            </span>
            Painel Administrativo
          </router-link>
        </li> -->

        <li @click="logout" class="viewmode">
          <span class="icon-svg">
            <!-- Ícone Sair -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M154.2 352c3.8-29.6 5.8-62.1 5.8-96c0-18.3-.6-36.1-1.7-53.4c12.4 8.3 29.4 7 40.4-4l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L233.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L334 299l30.9-82.4 5.1 12.3C385 264.7 419.9 288 458.7 288l21.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-21.3 0c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c0 0 0 0-.1 .1C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256S35.8 512 80 512c25.3 0 47.8-37.5 62.5-96l55.1 0c19 0 36.2-11.2 43.9-28.5L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L187.2 352l-33 0zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>
          </span>
          Sair
        </li>
      </ul>
      <div class="version">
        <p>Versão: {{ versionPortalWeeduc }}</p>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import logo from '@/assets/logo.png'
import logoWhite from '@/assets/logo_white.png'

export default {
  name: 'MobileMenu',
  props: {
    showMenuMobile: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(['dark', 'typeId', 'user']),
    ...mapState('portal', ['dataWebsitePortal2']),
    name() {
      return this.user?.name?.substring(0, 2) || ''
    },
    fullName() {
      return this.user?.name || ''
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  methods: {
    mapState,
    ...mapActions(['toggleDarkMode']),
    // Agora, ao invés de fechar localmente, emitimos um evento para o Header.vue fechar
    fecharMenuHeader() {
      this.$emit('fechar-menu-header')
    },
    changeViewMode() {
        const darkLocal = !this.dark;
        this.toggleDarkMode({ dark: darkLocal });
    },
    logout() {
      this.$emit('logout')
    },
    handleClickOutside(event) {
      if (!this.showMenuMobile) return
      const menu = this.$refs.menuMobile
      if (menu && !menu.contains(event.target)) {
        this.fecharMenuHeader()
      }
    }
  },
  data() {
    return {
      logo,
      logoWhite,
      versionPortalWeeduc: process.env.VERSION_PORTAL_WEEDUC
    }
  }
}
</script>

<style scoped>
.menu-mobile-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(24, 26, 32, 0.55);
  z-index: 2099;
  transition: opacity 0.3s;
}

.menu-mobile {
  position: fixed;
  top: 0;
  right: 0;
  width: 82vw;
  max-width: 340px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 16px rgba(0, 0, 0, 0.12);
  z-index: 2100;
  display: flex;
  flex-direction: column;
  padding: 32px 24px 24px 24px;
  transform: translateX(100%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.menu-mobile.show {
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
}

.menu-mobile.dark {
  background: #181a20;
  color: #fff;
}

.logoMobile {
  margin-bottom: 20px;
}

.menu-mobile-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.menu-mobile-list li {
  width: 100%;
}

.menu-mobile-list a {
  display: flex;
  align-items: center;
  color: #003e41;
  font-size: 16px;
  text-decoration: none;
  padding: 10px 0;
  transition: color 0.2s;
  font-weight: 500;
}

.menu-mobile-list a:hover {
  color: #19c7d0;
}

.icon-svg {
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
}

.logo_name {
  font-weight: bold;
  margin-right: 4px;
}

.fullName {
  font-style: italic;
  opacity: 0.9;
}

@media (max-width: 480px) {
  .menu-mobile {
    width: 60%;
    padding: 30px;
    border-radius: 10px 0px 0px 10px;
    box-shadow: -8px -2px 15px 0px rgb(84 84 84);
  }
  a.user-info {
    gap: 10px;
    }
span.line {
    width: 85%;
    background-color: #e4e4e4;
    height: 1px;
    position: absolute;
    left: 20px;
}
li.viewmode {
    padding: 10px 0;
    text-align: left;
}

}
.version {
    position: absolute;
    bottom: 0;
    font-size: 11px;
}
span.icon-svg svg {
    height: 20px;
    width: 20px;
}
span.icon-svg svg path {
    fill: #1bc7d0;
}
span.icon-dark, span.icon-light {
    display: flex;
    align-items: center;
}
span.icon-dark p, span.icon-light p{
   padding-top: 5px;
   color: #003e41;
   font-weight: 500;
}
li.viewmode{
    padding-top: 5px;
    color: #003e41;
    font-weight: 500;
 }
    .dark li.viewmode{
    padding-top: 5px;
    color: #ffffff;
    font-weight: 500;
 }
 .dark span.icon-dark p, .dark span.icon-light p {
    padding-top: 5px;
    color: #ffffff;
    font-weight: 500;
}
</style>